import Container from "components/grid/container";
import SuggestedListings from "src/components/listing-detail/suggested-listings";
import styles from "./styles.module.css";

const SimilarListingsData = ({ similarData }) => {
  return (
    <Container>
      <div className={styles.similarListingsBox}>
        <span className={styles.title}>Benzer İlanları İnceleyebilirsiniz</span>
        <SuggestedListings statusCode={410} data={similarData} />
      </div>
    </Container>
  );
};

export default SimilarListingsData;
